import { useCallback, useEffect, useState } from 'react'

import fileDownload from 'js-file-download'

import api, { csv, zip } from 'common/api'

type FilesResponse = {
  id: string
  scid: number
  syncTimeFrom: Date
  syncTimeTo: Date
  recordCount: number
  sentDate: Date
  filename: string
  fileSize: number
  gcsFilePath: string
}

export const useGetStudentInquiresFiles = ({ scid }: { scid: number }) => {
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState<FilesResponse[]>([])

  const fetch = useCallback(async () => {
    setLoading(true)
    api
      .get<FilesResponse[]>(`/api/student/interest_sharing/${scid}`)
      .then((response) => {
        setFiles(response ?? [])
        setLoading(false)
      })
      .catch(() => {
        setFiles([])
        setLoading(false)
      })
  }, [scid])

  useEffect(() => {
    fetch()
  }, [fetch])
  return { loading, files }
}

export const downloadFile = async ({ scid, fileId, fileName }: { scid: number; fileId: string; fileName: string }) => {
  csv.get(`/api/student/interest_sharing/${scid}/${fileId}`).then((fileBlob) => {
    fileDownload(fileBlob, fileName)
  })
}

export const bulkDownloadFiles = ({ scid, fileIds }: { scid: number; fileIds: string[] }) => {
  const payload = { fileIds: fileIds }
  zip.post(`/api/student/interest_sharing/${scid}/files`, payload).then((fileBlob) => {
    fileDownload(fileBlob, 'inquiries_files.zip')
  })
}
